import { MuiAlert, MuiAlertTitle } from './MuiAlert';
import { MuiAppBar } from './MuiAppBar';
import { MuiAutocomplete } from './MuiAutocomplete';
import { MuiAvatar } from './MuiAvatar';
import { MuiButton } from './MuiButton';
import { MuiButtonBase } from './MuiButtonBase';
import { MuiCard } from './MuiCard';
import { MuiCardActionArea } from './MuiCardActionArea';
import { MuiCardContent } from './MuiCardContent';
import { MuiCheckbox } from './MuiCheckbox';
import { MuiChip } from './MuiChip';
import { MuiContainer } from './MuiContainer';
import { MuiCssBaseline } from './MuiCssBaseline';
import { MuiDialog } from './MuiDialog';
import { MuiDialogActions } from './MuiDialogActions';
import { MuiDialogContent } from './MuiDialogContent';
import { MuiDialogContentText } from './MuiDialogContentText';
import { MuiDialogTitle } from './MuiDialogTitle';
import { MuiDivider } from './MuiDivider';
import { MuiDrawer } from './MuiDrawer';
import { MuiFilledInput } from './MuiFilledInput';
import { MuiFormControlLabel } from './MuiFormControlLabel';
import { MuiFormHelperText } from './MuiFormHelperText';
import { MuiIconButton } from './MuiIconButton';
import { MuiInputBase } from './MuiInputBase';
import { MuiInputLabel } from './MuiInputLabel';
import { MuiLinearProgress } from './MuiLinearProgress';
import { MuiLink } from './MuiLink';
import { MuiListItemText } from './MuiListItemText';
import { MuiListSubheader } from './MuiListSubheader';
import { MuiMenu } from './MuiMenu';
import { MuiMenuItem } from './MuiMenuItem';
import { MuiOutlinedInput } from './MuiOutlinedInput';
import { MuiPaginationItem } from './MuiPaginationItem';
import { MuiPaper } from './MuiPaper';
import { MuiPopper } from './MuiPopper';
import { MuiRadio } from './MuiRadio';
import { MuiRating } from './MuiRating';
import { MuiSelect } from './MuiSelect';
import { MuiSkeleton } from './MuiSkeleton';
import { MuiSlider } from './MuiSlider';
import { MuiSwitch } from './MuiSwitch';
import { MuiTab } from './MuiTab';
import { MuiTableBody } from './MuiTableBody';
import { MuiTableCell } from './MuiTableCell';
import { MuiTableContainer } from './MuiTableContainer';
import { MuiTablePagination } from './MuiTablePagination';
import { MuiTableRow } from './MuiTableRow';
import { MuiTableSortLabel } from './MuiTableSortLabel';
import { MuiTabs } from './MuiTabs';
import { MuiToggleButton } from './MuiToggleButton';
import { MuiToolbar } from './MuiToolbar';
import { MuiTooltip } from './MuiTooltip';
import { MuiTypography } from './MuiTypography';

import type { Components, Theme } from '@mui/material';

export const components: Components<Theme> = {
  MuiAlert,
  MuiAlertTitle,
  MuiAppBar,
  MuiAutocomplete,
  MuiAvatar,
  MuiButton,
  MuiButtonBase,
  MuiCard,
  MuiCardActionArea,
  MuiCardContent,
  MuiCheckbox,
  MuiChip,
  MuiContainer,
  MuiCssBaseline,
  MuiDialog,
  MuiDialogActions,
  MuiDialogContent,
  MuiDialogContentText,
  MuiDialogTitle,
  MuiDivider,
  MuiDrawer,
  MuiFilledInput,
  MuiFormControlLabel,
  MuiFormHelperText,
  MuiIconButton,
  MuiInputBase,
  MuiInputLabel,
  MuiLinearProgress,
  MuiLink,
  MuiListItemText,
  MuiMenu,
  MuiMenuItem,
  MuiOutlinedInput,
  MuiPaginationItem,
  MuiPaper,
  MuiPopper,
  MuiRadio,
  MuiRating,
  MuiSelect,
  MuiSkeleton,
  MuiSlider,
  MuiSwitch,
  MuiTab,
  MuiTableBody,
  MuiTableCell,
  MuiTableContainer,
  MuiTablePagination,
  MuiTableRow,
  MuiTableSortLabel,
  MuiTabs,
  MuiToggleButton,
  MuiToolbar,
  MuiTooltip,
  MuiTypography,
  MuiListSubheader,
};
